import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SearchIcon, HammerIcon, MessageCircleIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSolution() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    icon: SearchIcon,
    text: 'Encontrar negocios locales que necesitan un sitio web (en minutos, no en horas)'
  }, {
    icon: HammerIcon,
    text: 'Construir un sitio web profesional para ese negocio (sin saber diseño ni código)'
  }, {
    icon: MessageCircleIcon,
    text: 'Cerrar la venta con un guion probado (aunque nunca hayas vendido nada)'
  }, {
    icon: DollarSignIcon,
    text: 'Cobrar entre $300 y $500 por sitio (con recurrencia mensual opcional)'
  }];
  return <section ref={ref} className="w-full py-20 px-4" data-id="element-324">
      <div className="max-w-6xl mx-auto" data-id="element-325">
        {/* Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-326">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-327">
            ¿Por Qué la Mayoría Nunca Gana Dinero con Servicios Digitales?
          </h2>

          <div className="max-w-3xl mx-auto space-y-4 font-body text-lg text-gray-300" data-id="element-328">
            <p data-id="element-329">
              Hay millones de negocios locales ahí afuera: restaurantes,
              peluquerías, talleres mecánicos, dentistas, tiendas de ropa.
              Muchos no tienen sitio web. Muchos otros tienen uno que parece
              hecho en 2005.
            </p>
            <p data-id="element-330">
              Ellos necesitan tu ayuda. Y están dispuestos a pagar por ella.
            </p>
            <p className="text-gold font-semibold" data-id="element-331">
              El problema no es el mercado. El mercado es enorme. El problema es
              que la mayoría de la gente cree que necesita ser diseñador o
              programador para ofrecer este servicio. Y eso los paraliza antes
              de empezar.
            </p>
            <p className="text-xl font-bold text-white" data-id="element-332">
              La verdad es que ya no necesitas serlo.
            </p>
          </div>
        </motion.div>

        {/* Solution */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="bg-gradient-to-br from-gold/10 to-gold/5 border border-gold/30 rounded-2xl p-8 md:p-12" data-id="element-333">
          <h3 className="font-heading font-bold text-3xl md:text-4xl text-center mb-4" data-id="element-334">
            Presentamos el{' '}
            <span className="text-gold" data-id="element-335">"AI Web Closer System"</span>
          </h3>

          <p className="font-body text-lg text-center text-gray-300 mb-10 max-w-3xl mx-auto" data-id="element-336">
            El AI Web Closer System es un mini-curso de acción rápida que te
            enseña a usar un cerebro de IA personalizado para:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-337">
            {features.map((feature, index) => {
            const Icon = feature.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.6,
              delay: 0.5 + index * 0.1
            }} className="flex items-start gap-4 bg-navy-dark/50 p-6 rounded-xl border border-gold/10" data-id="element-338">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold/20 rounded-lg flex items-center justify-center" data-id="element-339">
                    <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-340" />
                  </div>
                  <p className="font-body text-base text-gray-300 leading-relaxed" data-id="element-341">
                    {feature.text}
                  </p>
                </motion.div>;
          })}
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.8,
          delay: 1
        }} className="mt-10 text-center space-y-2" data-id="element-342">
            <p className="font-body text-lg text-gray-300" data-id="element-343">
              No necesitas experiencia. No necesitas un portafolio. No necesitas
              saber de tecnología.
            </p>
            <p className="font-heading font-bold text-2xl text-gold" data-id="element-344">
              Solo necesitas seguir el sistema.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}